import React from 'react';
import styles from './introAGradient.module.scss';

export const IntroAGradient: React.FC = () => <div className={styles.gradient} />;
